<script>
import {mapActions, mapState} from 'pinia';
import { orderStore } from '@/components/order-vue/stores/order.js';
import FormCheckbox from '@/components/order-vue/order/components/form/form-checkbox.vue';

export default {
	components: { FormCheckbox },
	
	computed: {
		...mapState(orderStore, ['userAgreement'])
	},
	
	methods: {
		...mapActions(
			orderStore,
			{
				setUserAgreementStatus: 'changeUserAgreementStatus',
			}
		)
	}
};
</script>
<template>
	<FormCheckbox
		id="checkout-options-confirm"
		:class="{ 'checkout-item__agreement' : true }"
		v-bind:model-value="userAgreement"
		:required="true"
		:look="true"
		@update:model-value="setUserAgreementStatus"
	>
		<span class="form-checkbox__label" v-html="$loc.get('PRIVACY_AGREEMENT_LINK_TEXT')"></span>
	</FormCheckbox>
</template>
